'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.prefixAllFlat = exports.prefixValue = exports.prefixProperty = undefined;

var _reduce = require('lodash/reduce');

var _reduce2 = _interopRequireDefault(_reduce);

var _each = require('lodash/each');

var _each2 = _interopRequireDefault(_each);

var _find = require('lodash/find');

var _find2 = _interopRequireDefault(_find);

var _startsWith = require('lodash/startsWith');

var _startsWith2 = _interopRequireDefault(_startsWith);

var _utils = require('./utils');

var _prefixes = require('./prefixes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cache = {};
var supportedProperties = function () {
  return _utils.isBrowser ? document.createElement('p').style : {};
}();

var VENDORS = {
  opera: 'O',
  chrome: 'webkit',
  safari: 'Webkit',
  firefox: 'Moz',
  msie: 'ms',
  node: ''
};

var jsPrefix = function () {
  if (typeof navigator === 'undefined') {
    console.warn('CXSync: No navigator found: I hope you are running this on the server.');
    return '';
  }
  var ua = navigator.userAgent.toLowerCase();
  var match = /(opera|msie|firefox|chrome|safari|node)/.exec(ua);
  if (!match) console.warn('CXSync: No vendor match found: This browser is not officially supported and vendor prefixes will be absent.');
  return match ? VENDORS[match[0]] : '';
}();

var cssPrefix = '-' + jsPrefix.toLowerCase() + '-';

var prefixProperty = exports.prefixProperty = function prefixProperty(property) {
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : jsPrefix;

  var cacheKey = property + prefix;
  if (cacheKey in cache) return cache[cacheKey];
  var prefixed = prefix + property.slice(0, 1).toUpperCase() + property.slice(1);

  if (!prefix || property in supportedProperties) {
    cache[cacheKey] = property;
  } else if (_prefixes.ALTERNATE_PROPS[property] in supportedProperties) {
    cache[cacheKey] = _prefixes.ALTERNATE_PROPS[property];
  } else if ((0, _find2.default)(_prefixes.PREFIXABLE_PROPS, function (p) {
    return (0, _startsWith2.default)(property, p);
  }) && prefixed in supportedProperties) {
    cache[cacheKey] = prefixed;
  } else {
    console.warn('CXSync: No valid version of property ' + property + ' found, using provided but it is not supported.');
    cache[cacheKey] = property;
  }

  return cache[cacheKey];
};

var prefixValue = exports.prefixValue = function prefixValue(property, value) {
  if (typeof value !== 'string' || !isNaN(parseInt(value, 10))) return value;
  if (property === 'content' && value === '') value = '""';
  var cacheKey = property + value;
  if (cacheKey in cache) return cache[cacheKey];

  var tryValue = function tryValue(value) {
    supportedProperties[property] = '';
    supportedProperties[property] = value;
    return !!supportedProperties[property].length;
  };

  try {
    tryValue(value);
  } catch (err) {
    // IE is shit
    return value;
  }

  var prefixed = cssPrefix + value;
  var alternate = (0, _find2.default)(_prefixes.ALTERNATE_VALUES[value], tryValue);

  if (tryValue(value)) {
    cache[cacheKey] = value;
  } else if ((0, _find2.default)(_prefixes.PREFIXABLE_VALUES, function (v) {
    return (0, _startsWith2.default)(value, v);
  }) && tryValue(prefixed)) {
    cache[cacheKey] = prefixed;
  } else if (alternate) {
    cache[cacheKey] = alternate;
  } else {
    console.warn('CXSync: No valid version of value ' + value + ' for property ' + property + ' found, using provided but it is not supported.');
    cache[cacheKey] = value;
  }

  return cache[cacheKey];
};

var prefixAllFlatReducer = function prefixAllFlatReducer(res, val, prop) {
  if ((0, _utils.isStyleProp)(prop) && !(0, _utils.isObj)(val)) {
    (0, _each2.default)(VENDORS, function (prefix) {
      var prefixed = prefixProperty(prop, prefix);
      res[prefixed] = prefixValue(prefixed, val);
    });
  } else {
    res[prop] = val;
  }
  return res;
};

var prefixAllFlat = exports.prefixAllFlat = function prefixAllFlat(style) {
  return (0, _reduce2.default)(style, prefixAllFlatReducer, {});
};